import { c as _c } from "react/compiler-runtime";
import { LinkButton } from "@repo/ui/link-button";
import { ActionLink } from "@/components/common/actions/actions.component";
import { AudienceTabs } from "@/components/navigation/audience-tabs.component";
import { getI18nString } from "@/lib/utils";
import type { UtilityMenuItem } from "@/components/navigation/navigation.types";
interface UtilityBarProps {
  items: UtilityMenuItem[] | null;
}
export function UtilityBar(t0) {
  const $ = _c(5);
  const {
    items
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AudienceTabs variant="desktop" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== items) {
    t2 = items && items.length > 0 && <nav className="flex" aria-label="Utility navigation"><ul className="flex items-center gap-[37px]">{items.map(_temp)}</ul></nav>;
    $[1] = items;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="hidden desktop-lg:block border-b border-border-subtle"><div className="flex items-stretch justify-between px-12">{t1}{t2}</div></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(item) {
  return item?.to ? <li key={item._id}><LinkButton asChild={true} variant="primary" size="sm"><ActionLink actionTo={item.to}>{getI18nString(item.text, "Link")}</ActionLink></LinkButton></li> : null;
}